export enum GovernanceEvent {
    // Tab views — page-level navigation is captured by App Insights auto-pageViews;
    // policy counts are emitted by the BE on policy lifecycle events.
    PoliciesTabViewed = 'Governance.PoliciesTabViewed',
    TracesTabViewed = 'Governance.TracesTabViewed',

    // Policy wizard funnel
    PolicyWizardStarted = 'Governance.PolicyWizardStarted',
    PolicyWizardStepViewed = 'Governance.PolicyWizardStepViewed',
    PolicyWizardStepCompleted = 'Governance.PolicyWizardStepCompleted',
    PolicyWizardAbandoned = 'Governance.PolicyWizardAbandoned',

    // Policy lifecycle (FE-tracked subset; PolicySaved + PolicyDeleted are BE-covered)
    PolicyEdited = 'Governance.PolicyEdited',
    PolicyModeSelected = 'Governance.PolicyModeSelected',

    // Traces page
    TraceFiltersApplied = 'Governance.TraceFiltersApplied',
    TraceDetailsViewed = 'Governance.TraceDetailsViewed',

    // Upgrade-gate clicks (renamed from AccessPolicy.* for consistency)
    ClickedGovernance = 'Governance.ClickedGovernance',
    ClickedGovernanceUpgrade = 'Governance.ClickedGovernanceUpgrade',
    ClickedGovernanceContact = 'Governance.ClickedGovernanceContact',
}
